import React, { useContext, useEffect, useState } from "react";
import { Error } from "../../../commons/Messages/Messages";
import axios from "axios";
import { isAuthenticated } from "../../../commons/Auth/auth";
import { SocketContext } from "../../../context/SocketContext";
import ProjectLists from "../../../commons/Projects/ProjectLists";
import { generalErrorAlert } from "../../../commons/GeneralErrorAlert";
import Loading from "../../../commons/Loading/Loading";

const Projects = () => {
  const socket = useContext(SocketContext);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState("");
  const [searchText, setSearchText] = useState("");
  const [pageNo, setPageNo] = useState(1);
  const [pageSize] = useState(6);

  const handleSearch = value => {
    setSearchText(value);
    setPageNo(1);
  };

  const getData = async () => {
    setLoading(true);
    await axios
      .post(
        `${process.env.REACT_APP_BACKEND_URL}/projects/limited`,
        {
          serviceProvider: isAuthenticated()?.serviceProviderId,
          searchText,
          pageSize,
          pageNo: pageNo - 1
        },
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token")
          }
        }
      )
      .then(res => {
        if (res.status === 200 || res.status === 304) {
          setData(res.data.data);
          setTotalCount(res.data.count);
        } else {
          Error(res.data.errorMessage);
        }
      })
      .catch(err => {
        generalErrorAlert(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const refreshData = () => {
    getData();
  };

  useEffect(() => {
    if (socket) {
      socket.on("refresh service provider data", msg => {
        if (msg) {
          refreshData();
        }
      });
    }
  }, [socket]);

  useEffect(() => {
    getData();

    return () => {};
  }, [searchText, pageNo]);

  return loading ? (
    <Loading />
  ) : (
    <>
      <ProjectLists
        projectsArray={data}
        handleSearch={handleSearch}
        handlePageChange={val => setPageNo(val)}
        pageNo={pageNo}
        totalCount={totalCount}
        serviceProviderId={isAuthenticated()._id}
        serviceProvider
        pageSize={pageSize}
        updateParent={refreshData}
      />
    </>
  );
};

export default Projects;
